import { render, staticRenderFns } from "./EarthMagneticFieldViz.vue?vue&type=template&id=2f519d03&scoped=true"
import script from "./EarthMagneticFieldViz.vue?vue&type=script&lang=js"
export * from "./EarthMagneticFieldViz.vue?vue&type=script&lang=js"
import style0 from "./EarthMagneticFieldViz.vue?vue&type=style&index=0&id=2f519d03&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2f519d03",
  null
  
)

export default component.exports